import React from 'react';

/**
 * Écran de chargement: le logo de l'application, animé, au centre, sur le fond
 * de l'application (clair ou sombre). Aucun texte. Il n'existe que le temps du
 * chargement réel: le logo apparaît en fondu (pas de flash sur un chargement
 * très court) et disparaît dès que l'écran est prêt. Animation coupée pour qui
 * préfère moins de mouvement (voir index.css).
 */
const EcranChargement = () => (
  <div className="ecran-chargement" role="status" aria-busy="true" aria-label="Chargement">
    <div className="ecran-chargement__scene">
      <span className="ecran-chargement__halo" aria-hidden="true" />
      <img
        src="/brand/logo-mark.png"
        alt=""
        className="ecran-chargement__logo ecran-chargement__logo--clair"
        draggable={false}
      />
      <img
        src="/brand/logo-mark-sombre.png"
        alt=""
        className="ecran-chargement__logo ecran-chargement__logo--sombre"
        draggable={false}
      />
    </div>
  </div>
);

export default EcranChargement;
